module.exports = __webpack_public_path__ + "static/media/998114.b74b5701.png";